import { Link } from 'react-router-dom'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'
import useModel, { type CouponQuickLinkItem } from '../useModel'

const QUICK_LINKS_BACKGROUND = 'b6e9c076999ab928090d16c49f76e8cc.png'

const QuickLinks = () => {
  const { quickLinks } = useModel()

  return (
    <section className="group relative h-[445px] w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-700 ease-out group-hover:scale-105"
        style={{ backgroundImage: `url(${preFixImgUrl(QUICK_LINKS_BACKGROUND)})` }}
        aria-hidden
      />
      <nav className="relative z-[1] mx-auto grid h-full w-[1200px] grid-cols-3 items-center">
        {quickLinks.map((item: CouponQuickLinkItem) => {
          const className =
            'flex flex-col justify-center items-center text-center text-white no-underline group/link'
          const content = (
            <>
              <span className="flex h-[104px] w-[110px] items-center justify-center rounded-[20px] border border-white/60 bg-white/15 shadow-[inset_0_1px_0_rgba(255,255,255,0.18)] backdrop-blur-[4px] transition-[transform,background-color,box-shadow] group-hover/link:bg-white/25 group-hover/link:shadow-[0_10px_24px_rgba(0,66,150,0.18)]">
                <img
                  src={item.iconImg}
                  alt=""
                  className="h-[58px] w-[58px] object-contain brightness-0 invert transition-transform"
                  draggable={false}
                />
              </span>
              <LangText lngKey={item.key} className="mt-[28px] text-[30px] leading-[42px]" />
            </>
          )

          if ('href' in item) {
            return (
              <a key={item.key} href={item.href} className={className}>
                {content}
              </a>
            )
          }

          return (
            <Link key={item.key} to={item.to} className={className}>
              {content}
            </Link>
          )
        })}
      </nav>
    </section>
  )
}

export default QuickLinks
